import request from '@/plugins/axios'

export function AccountLogin(data) {
  return request({
    url: 'eids-invoice/user/login',
    method: 'post',
    data
  })
}